import AdminOrdersPage from '../../../components/admin/orders/AdminOrdersPage'

export default function Orders() {
  return <AdminOrdersPage />
}
